module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Wood-horse-2cd2cdf0f527f5596a4cb8df53dbd739.svg";